import { useEffect, useState } from "react";
const useAddModal = (selectedBidder) => {
    const [isOpen, setIsShowing] = useState(false);
    const [val, setVal] = useState({});
    function toggleModal(item) {
        setVal(selectedBidder);
      //setIsShowing(!isOpen);
      setIsShowing(prev => !prev);
      console.log(selectedBidder);
      console.log(item);
      setVal(item);
      console.log(val);
    }

    useEffect(()=>{console.log(val)},[val]);
  
    return {
      isOpen,
      val,
      toggleModal,
      
    }
  };
  
  export default useAddModal;